import { getContext } from '@fiverr-private/fiverr_context';

export const getPersonalizedCommonProps = (props) => {
    const { abTests } = getContext();
    const { personalizedContent = {} } = props;

    return {
        abTests,
        fallback: props.fallback,
        placeholder: props.placeholder,
        appName: props.appName,
        perseusName: props.perseusName,
        sectionName: props.sectionName,
        isLazy: props.isLazy,
        isLoading: props.isLoading,
        sliderBaseNum: props.sliderBaseNum,
        sliderBreakpoints: props.sliderBreakpoints,
        mixpanelMetadata: props.mixpanelMetadata,
        showTranslatedUGC: props.showTranslatedUGC,
        recentlyViewedChoiceGigs: props.recentlyViewedChoiceGigs,
        choiceAlgos: props.choiceAlgos,
        collectProps: props.collectProps,
        container: props.container,
        features: props.features ?? { useForcePriceRounding: true },
        headerTitleClass: props.headerTitleClass,
        displayISpeak: props.displayISpeak,
        funnelName: personalizedContent.funnelName,
        pageName: personalizedContent.pageName,
        contextReferrer: props.contextReferrer,
        onImpression: props.onImpression,
        biParams: props.biParams ?? {},
        extraParams: props.extraParams ?? {},
        rollouts: props.rollouts ?? {},
        onCardClick: props.onCardClick,
    };
};
